export const formatStatusForDisplay = (value, fallback = '') => {
    if (value === null || value === undefined) {
        return fallback;
    }

    const normalizedValue = String(value).trim();
    if (!normalizedValue) {
        return fallback;
    }

    if (normalizedValue.toUpperCase() === 'IN_PROGRESS') {
        return 'IN-PROGRESS';
    }

    return normalizedValue;
};
